/// <amd-module name="VSSUI/Registration/VssComponentRegistration" />
import { Callout } from "VSSUI/Callout";
import { TooltipHost } from "VSSUI/Tooltip";
import { VssComponent } from "VSS/Platform/Layout";
import { VssContextualMenu } from "../VssContextualMenu";
import { VssIcon } from "../VssIcon";
import { VssPersona } from "VSSUI/VssPersona";

VssComponent.register("contextualMenu", VssContextualMenu);
VssComponent.register("callout", Callout);
VssComponent.register("tooltipHost", TooltipHost);
VssComponent.register("vssIcon", VssIcon);
VssComponent.register("vssPersona", VssPersona);
